var helpers, libraries;

helpers = {};

libraries = {
  jquery: true,
  jqueryUi: true,
  knockout: true,
  knockoutValidation: true
};
